import React from 'react';

export function isEmailValid(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export function getAgreementText(source) {
  if (source === 'agencyTable') {
    return (
      <>
        <p>
          By clicking <strong>&quot;I Agree&quot;</strong> and providing your
          electronic signature below, you acknowledge that you are authorized to
          request the offboarding of the downline agent identified in this
          submission, and you are intentionally initiating this process on
          behalf of your agency.
        </p>
        <p>You understand and agree that:</p>
        <ul>
          <li>
            This request is being submitted{' '}
            <b>voluntarily and with proper authority</b> from your agency.
          </li>
          <li>
            O&apos;Neill will <b>immediately cease all work</b> on any pending,
            active, or prospective appointments for the agent being offboarded.
          </li>
          <li>
            You are responsible for ensuring that{' '}
            <b>your agency and the downline agent are aware</b> of this action
            and any consequences related to it.
          </li>
          <li>
            You and your agent will need to <b>monitor your email</b> for
            follow-up communications, required actions, or status updates
            related to this offboarding.
          </li>
          <li>
            Offboarding may affect the agent&apos;s contracting status,
            commission eligibility, system access, and carrier relationships,
            and O&apos;Neill is <b>not liable for delays or impacts</b> caused
            by carrier processes, third-party approvals, or incomplete or
            incorrect information provided by your agency.
          </li>
          <li>
            Once submitted, this request is <b>final</b> and the offboarding
            process <b>cannot be reversed</b> without completing a full
            re-onboarding.
          </li>
          <li>
            If a temporary contracting email address was created for the agent,
            you acknowledge that it will be{' '}
            <b>deactivated as part of the offboarding process</b> if it has not
            already been deactivated.
          </li>
        </ul>
        <p>
          By continuing, you confirm that you have read and understand the above
          statements, that you are acting within your authority, and that you
          authorize us to proceed with offboarding this agent.
        </p>
      </>
    );
  }

  return (
    <>
      <p>
        By clicking &quot;<b>I Agree</b>&quot; and providing your electronic
        signature, you acknowledge, understand, and expressly authorize our
        agency to begin the offboarding process.
      </p>
      <ul>
        <li>
          You are submitting this request <b>voluntarily and intentionally</b>.
        </li>
        <li>
          O&apos;Neill will <b>immediately cease all work</b> on your pending,
          active, or prospective appointments.
        </li>
        <li>
          When required, we will <b>contact your agency/upline entity</b> to
          obtain approval or notify them of your offboarding.
        </li>
        <li>
          You are responsible for{' '}
          <b>reviewing and responding to follow-up communications</b> sent to
          your email.
        </li>
        <li>
          You understand that offboarding may impact your contracting status,
          commission payments, system access, and carrier relationships.
        </li>
        <li>
          O&apos;Neill is <b>not responsible for delays or impacts</b> caused by
          third-party approvals, carrier processes, or incomplete information
          provided by you.
        </li>
        <li>
          Once submitted, this request is <b>final and cannot be reversed</b>{' '}
          without re-onboarding.
        </li>
        <li>
          If a temporary contracting email address was created for you, you
          acknowledge that it will be{' '}
          <b>deactivated as part of the offboarding process</b> if it has not
          already been deactivated.
        </li>
      </ul>
      <p>
        By continuing, you confirm you have read, understood, and agreed to
        these terms.
      </p>
    </>
  );
}
